import { render, staticRenderFns } from "./IcoDashboardSecurity.vue?vue&type=template&id=6698b91e&lang=html"
import script from "./IcoDashboardSecurity.vue?vue&type=script&lang=js"
export * from "./IcoDashboardSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports